// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import alertTriangleIcon from "@/assets/icons/alert-triangle.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type AlertTriangleIconProps = Omit<IconProps, "name">;

export function AlertTriangleIcon(props: AlertTriangleIconProps): React.ReactNode {
  return <Icon name={alertTriangleIcon} {...props} />;
}
